import React from 'react';
import PropTypes from 'prop-types';
import Anchor from '@fuww/library/src/Anchor';
import { ImageBrowserListItem } from '@fuww/library/src/ImageListItem';
import Image from '../../../Image';
import Schema from '../../Schema';
import { Link } from '../../../../routes.mjs';

export const ImageItem = ({
  title,
  width,
  imageUrls,
  preload,
  finalFetchpriority,
  placeholderFetchpriority,
  ...rest
}) => (
  <Image
    placeholder={imageUrls[0]}
    src={imageUrls[4]}
    srcSet={`${
      imageUrls[1]} 360w, ${
      imageUrls[2]} 540w, ${
      imageUrls[3]} 720w, ${
      imageUrls[4]} 1440w`}
    alt={title || 'Untitled'}
    width={width}
        // eslint-disable-next-line max-len
    sizes="(min-width: 1440px) 360px, (min-width: 858px) 25vw (min-width: 498px) 33vw, 100vw"
    preload={preload}
    finalFetchpriority={finalFetchpriority}
    placeholderFetchpriority={placeholderFetchpriority}
    {...rest}
  />
);

ImageItem.propTypes = {
  title: PropTypes.string,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
  width: PropTypes.string.isRequired,
  preload: PropTypes.bool,
  finalFetchpriority: PropTypes.string,
  placeholderFetchpriority: PropTypes.string,
};

ImageItem.defaultProps = {
  title: undefined,
  imageUrls: [],
  preload: false,
  finalFetchpriority: 'low',
  placeholderFetchpriority: 'low',
};

const Item = (properties) => {
  const {
    title,
    id,
    slug,
    imageUrls,
    width,
    route,
    preload,
    finalFetchpriority,
    placeholderFetchpriority,
  } = properties;
  const parameters = {
    id,
    ...(slug ? { slug } : {}),
  };

  return (
    <ImageBrowserListItem>
      <Link
        route={route}
        params={parameters}
        passHref
      >
        <Anchor href={imageUrls[1]}>
          <Schema {...properties} />
          <ImageItem
            title={title}
            width={width}
            imageUrls={imageUrls}
            preload={preload}
            finalFetchpriority={finalFetchpriority}
            placeholderFetchpriority={placeholderFetchpriority}
          />
        </Anchor>
      </Link>
    </ImageBrowserListItem>
  );
};

Item.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.number.isRequired,
  slug: PropTypes.string,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
  width: PropTypes.string.isRequired,
  route: PropTypes.string,
  preload: PropTypes.bool,
  finalFetchpriority: PropTypes.string,
  placeholderFetchpriority: PropTypes.string,
};

Item.defaultProps = {
  src: undefined,
  title: undefined,
  slug: undefined,
  imageUrls: [],
  route: 'lookbookImage',
  preload: false,
  finalFetchpriority: 'low',
  placeholderFetchpriority: 'low',
};

export default Item;
